import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Compras from './InformesMediosMagneticos';
import Ventas from './InformesMediosMagneticosVentas';

const App = () => {
  const history = useHistory();
  const location = useLocation();
  const tabFromUrl = new URLSearchParams(location.search).get('tab');
  const [activeKey, setActiveKey] = useState(tabFromUrl === 'ventas' ? 'ventas' : 'compras');

  const handleSelect = (key) => {
    setActiveKey(key);
    history.replace({ pathname: location.pathname, search: '?tab=' + key });
  };

  return (
    <Tabs activeKey={activeKey} onSelect={handleSelect} id="medios-magneticos-tabs" className="mb-3">
      <Tab eventKey="compras" title="Compras">
        <Compras />
      </Tab>
      <Tab eventKey="ventas" title="Ventas">
        <Ventas />
      </Tab>
    </Tabs>
  );
};

export default App;
